﻿import * as types from './mutation-types';
import * as mutations from './mutations';
import * as actions from './actions';
import * as getters from './getters'
const state = {
    context: null,
    orderStored: false,    
    customerWantsCreditAgreement: false,    
    inErrorState: false,
    isNewTeliaCustomer: true,
    showTFSummaryInformation: false,
    legalOwnerEmailFromCDS:'', 
    salesChannel:'',
    pageLoader:{
        showLoader:false,
        loaderTitle:'Processing...',
        loaderMessage:'Please do not close the browser window',
        loaderPreAuthTitle:'Customer Look-up',
        loaderPreAuthMessage:'We are verifying if customer is new or existing Telia Delbetalings customer',
        loaderCreditCheckTitle:'Credit Evaluation',
        loaderCreditCheckMessage:'Credit evaluation is being performed. Please wait.',
        loaderSubmitOrderTitle:'ORDER IS BEING PROCESSED',
        loaderSubmitOrderMessage:'Please do not close the browser window',
        loaderGetOrderTitle:'Order details',
        loaderGetOrderTitle: 'Please wait the order details to be processed',
        loaderSetCreditCheckNewCreditLimitLoaderTitle: '', //creditEvaluation
        loaderSetCreditCheckNewCreditLimitLoaderMessage: '', //creditEvaluation
        loaderUpdateHardwarePaymentLoaderTitle: '', //orderitems
        loaderUpdateHardwarePaymentLoaderMessage: '', //orderitems
        loaderResetCreditCheckNewCreditLimitLoaderTitle: '', //pageNavigation
        loaderResetCreditCheckNewCreditLimitLoaderMessage: '', //pageNavigation
        loaderGoToSummaryLoaderTitle: '', //pageNavigation
        loaderGoToSummaryLoaderMessage: '', //pageNavigation
        loaderGoToPaymentSelectionLoaderTitle: '', //pageNavigation
        loaderGoToPaymentSelectionLoaderMessage: '', //pageNavigation
        loaderGoToTangoLoaderTitle: '', //pageNavigation
        loaderGoToTangoLoaderMessage: '' //pageNavigation
    }, 
    digitalSigningModal:
    {
        multipleSignatures:false,
        documentsSigned:false,
        orderId:'',        
        signatureLeft:0,
        signatures:[
        {
            ErrorMessage:'',
            FailedSigning:'',
            FlagedSignature:'',
            FullName:'',
            MarkedAsSigned:'',
            SignatureDetails:[{
                DocumentId:'',
                SignatureAttribute:'',
                SignaturesName:''
            }],
        }
        ],
        selectedSigner:null
    },
    pageDetails:{
        isPaymentPage:true,
        paymentUrl:'',
        summaryUrl:'',
        tangocourl:'',
        tango4durl:'',
        tangoRedirectUrl:''
    },  
    discounts:{
        showDiscounts:false,
        discountType:"NoDiscount"
    },
    order: {
        orderId: '',
        dealerCode: '',
        orderGuid: '',
        discount: 0,
        billingAccountNumber: '',
        salesAgent: '',
        channelType: '',
        useNewDiva: false,
        manualSigning:true,
        modifiableByCustomer: true,
        orderer: {
            person:{
                name:{
                    firstName: '',
                    lastName: ''
                }
            },
            streetAddress:{
                zipCode: '',
                city: '',
                streetName: '',
                streetNumber: '',
                streetNumberSuffix: '',
                floorNumber: '',
                doorNumber: '',
                country: ''
            }
        },
        existingAgreement: null,
        agreementOrderItem: null,
        accountOrderItem: {            
            invoiceReceiver: { 
                emailAddress: null,
                foreignerAddress: null,
                identityData: null,
                organization: null,
                person: {
                    birthDate: null,
                    gender: null,
                    name: {
                        firstName: null,
                        lastName: null
                    }
                },                   
                streetAddress: {                     
                    zipCode: '',
                    city: '',
                    streetName: '',
                    streetNumber: '',
                    streetNumberSuffix: '',
                    floorNumber: '',
                    doorNumber: '',
                    country: ''                   
                },
                postOfficeBoxAddress: {                     
                    postBoxNumber: '',
                    postBoxName: '',
                    zipCode: '',
                    city: '',
                    country: ''               
                }
            },
            legalResponsibleEmail:'',
            legalResponsibleTelephone:null,
            billConfiguration:
                {                   
                    paymentMethod: {
                        name: '',
                        parameter:[]
                    }
                }
                ,
            billingAccountNumber:'',           
            fees:
                {
                    fee:[{
                        code:'',
                        price:{
                            VAT: 0,
                            amount: 0,
                            currency: ''
                        },
                        waiwed:false
                    }]
                }           
        },
        orderItems: null,
        creditCheckDetails: {
            externalCreditCheck: {
                creditStepsAvailable: [],
                currentCreditLimit: null,
                newCreditLimit: null,
                availableAmount: null,
                customerStatus: null
            }
        },
        hardwareDelivery: {
            deliveryAddress: {
                attention:'',
                city:'',
                coName:'',
                country:'',
                direction:'',
                doorNumber:'', 
                floorNumber:'',
                locality:'',
                streetName:'',
                streetNumber:'',
                streetNumberSuffix:'',
                zipCode:'' 
            },
            deliveryContactEmail: '',
            deliveryContactNumber: {
                areaCode:'',
                countryCode:'',
                localNumber:'',
            },
            deliveryMethod: '',
            deliveryStatus: '',
            deliveryStatusMessage: '',
            dispatchDate: null,
            externalDeliveryNote: '',
            internalDeliveryNote: '',
            logisticsDeliveryMethod: {
                deliveryCode: '',
                price:  {
                    VAT: 0,
                    amount: 0,
                    currency: ''
                },
                deliveryLocation:
                {
                    deliveryLocationAddress: {
                        attention:'',
                        city:'',
                        coName:'',
                        country:'',
                        direction:'',
                        doorNumber:'', 
                        floorNumber:'',
                        locality:'',
                        streetName:'',
                        streetNumber:'',
                        streetNumberSuffix:'',
                        zipCode:'' 
                    },
                    deliveryLocationCode:'',
                    deliveryLocationName:''

                }
            },
            preferredContactMethod: '',
            recipient: {
                person:{
                    name:{
                        firstName: '',
                        lastName: ''
                    }
                },
                streetAddress:{
                    attention:'',
                    city:'',
                    coName:'',
                    country:'',
                    direction:'',
                    doorNumber:'', 
                    floorNumber:'',
                    locality:'',
                    streetName:'',
                    streetNumber:'',
                    streetNumberSuffix:'',
                    zipCode:''
                },
                emailAddress:'',
                telephoneNumber:''
            },
            shippingRequestedDate: null,
            chargeHardwareDelivery: null
        },
         paymentBy: '',
    },
    orderUpdates: [],
    isCreditCheckValid: false,
    minCreditPayment:0,
    totalMonthlyInstallment: 0,
    creditAgreement: {
        subscriptionAgreementItems: [],
        totalCredit: 0,
        totalPerMonth: 0,
        payNow: 0,
        upfrontAmount: 0,
        numberOfInstallments: 0,
        lastInstallment: 0,
        monthlyPayment: 0,
    },
    creditEvaluation: {
        selectedCreditLimit: null,      
        creditCheckResult:{
            requestedCreditLimit: 0,
            approvedCreditLimit: {
                VAT: 0,
                amount: 0,
                currency: ''
            },
            creditTerms: [],
            code: '',
            approved: false,
            showDecision: false,
            creditCheckRef: '',
            statusCode:'', 
            underwritable:false,
            joiceId:'',
            joiceStatusCode:'',
            joiceStatusText:''
        },
        initState: true,
        approvedWithLowerLimit: 0
    },
    preAuth: {
        status: '',
        statusDescription: '',
        creditLimit: -1,
        availableAmount: -1,
        availableCreditLimits: [],
        preselectedLimit: 0, 
        isSuccessful:false,
        successfulCodes:["0","6","8", 0, 6, 8],
        blockedCode:["7",7],
        expiredCode:["11",11],
        stored: false,
        blocked: false
    },
    joiceCreditCheck: {
        status: '',
        statusDescription: '',
        creditAccountLimit: -1,
        creditAccountCurrentLimit: [],
        creditAccountOpenAmount:-1,
        creditAccountCurrentAvailableAmount: -1,
        creditAccountMaxAvailableAmount: -1,
        tfAccountExists: false,
        maxAvailableAmount: 0,
        isSuccessful:false,
        stored: false,
        errorMessage:''
    },
    downPaymentPlan: {
        plans: [
            {
                id: 0,
                hardwareBrand: "",
                hardwareType: "",
                allowedPaymentMethods: null,
                minInstallmentAmount: 0,
                minUpfrontPayment: 0,
                minNumberOfInstallments: 0,
                maxNumberOfInstallments: 0,
                installmentStepAmount: 0,
                minTotalPayment: 0,
                agreementType: "",
                agreementSubType: "",
                allowedInstalments: null,
                upfrontPayment: 0,
            }
        ],
        stored: false
    },
    pbsInformation: {
        bankName: '',
        regNumber: '',
        accountNumber: '',
        newTFCustomer: false
    },
    paymentMethod: '',
    contracts: {
        hasAnyContract: false,
        hasAnyTeliaContract: false,
        contractsSigned: false,
        showTeliaContracts: false,
        showTFContracts: false,
        checkCTC: false,
        checkCTFC: false,  
        validEmails: false, 
        teliaContracts:null,
        tfContracts:null,
        additionalInformation:'',
        salesAgentEmail:'',
        customerEmail:'',
        signatureOwnerFullName:'',
        signingError: {
            message: '',
            show: false
        }
    },   
    submitOrder:{
        externalTransactionId: null,
        personalAccountNumber: null
    },
    successfulSigning:null,
    warnings:{      
        pbsInfoWarning:{
            show: false,
            message: ''
        },
        customerEmail:{
            show: false,
            message: ''
        },
    },
    modalTexts:{
        'orderState': '',           //orderInfo, orderSummary
        'getOrder': '',             //orderInfo, orderSummary
        'preAuthBlocked': '',       //orderInfo
        'preAuthExpired': '',       //orderInfo
        'preAuthGeneral': '',       //orderInfo
        'preAuthData': '',          //orderInfo
        'downPaymentPlan': '',      //orderInfo
        'updateOrder': '',          //orderInfo
        'getOrderUpdates': '',      //orderInfo
        'creditCheck': '',          //creditEvaluation
        'contracts': '',            //orderSummary
        'checkSignature': '',       //orderSummary
        'cancelOrder': '',          //pageNavigation
        'installmentsNotSet': '',   //pageNavigation
        'createExternalPayment': '',   //pageNavigation
        'blockedPopup':'',          //orderSummary
        'submitOrder':'',           //orderSummary
        'submitOrderState1': '',    //orderSummary
        'submitOrderState2': '',     //orderSummary
        'submitOrderForRemoteChannel': '',//submitOrderForRemoteChannel
        'joiceOrderRejected': '', // orderInfo
        'joiceCreditCheckData': '', ////orderInfo
        'joiceOrderRetry': '', // orderInfo
    },
    buttonTexts: {
        'close': 'Close',
        'closeContinue': 'Continue',
        'refresh': 'Continue',
        'cancel': 'Cancel Order',
        'retryCreditCheck': 'Retry Credit Check',
        'retryPreAuth': 'Retry Look-up',
        'retryJoiceCreditCheck': 'Retry Credit Check',
        'resubmit': 'Re-submit',
        'submit': 'Submit Order',
        'returnToTango': 'Return to Tango'
    },
    alertModal : {
        show : false,
        active: false,
        icon: 'default',
        context: '',
        headline: '',
        message: '',
        buttons: [],
        digitalSignatureLabels:{
            name:'Name',
            contracts:'Contracts',
            sign:'Sign'
        }
    },
    constants: {
        returnLabelMaterialIds: []
    }
};

export default{
    state,
    getters,
    mutations,
    actions
}